var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export var isOptionType = function (option) {
    return (option === null || option === void 0 ? void 0 : option.value) !== undefined && (option === null || option === void 0 ? void 0 : option.label) !== undefined;
};
export var transformOptionValues = function (obj) {
    if (!obj)
        return obj;
    if (isOptionType(obj))
        return obj.value;
    if (typeof obj === "number" || typeof obj === "string" || typeof obj === "boolean") {
        if (obj === "true")
            return true;
        if (obj === "false")
            return false;
        return obj;
    }
    var transformedValues = {};
    Object.entries(obj).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        if (isOptionType(value)) {
            transformedValues[key] = value.value;
        }
        else if (Array.isArray(value)) {
            transformedValues[key] = value.map(function (data) { return transformOptionValues(data); });
        }
        else if (typeof value === "string") {
            transformedValues[key] = value.trim().length > 0 ? value.trim() : undefined;
        }
        else if (typeof value === "object") {
            transformedValues[key] = transformOptionValues(value);
        }
        else {
            transformedValues[key] = value;
        }
    });
    return transformedValues;
};
//# sourceMappingURL=cfFilterCommonUtils.js.map